angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/requests/requests.html',
    '<update-title title="PEforHire.com"></update-title>\n' +
    '<!-- Requests -->\n' +
    '<section class="content dashboard">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <div id="welcomeMessage" class="col-xs-12" ng-cloak>\n' +
    '                <!-- Message if the list is empty-->\n' +
    '                <div id="welcome" ng-cloak class="dashboard-box" ng-if="!first && isEmptyRequestList()">\n' +
    '                    <a class="pull-right close" onclick="document.getElementById(\'welcome\').className=\'hidden\';"></a>\n' +
    '                    <h2 class="welcome">Zero Active Requests {{$state.params.first}}\n' +
    '                        </span>\n' +
    '                    </h2>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-8 welcome">\n' +
    '                            <p>You don\'t have any requests at this time. You will be notified when a project is posted that\n' +
    '                                is a match for you.</p>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <!-- Welcome message first time-->\n' +
    '                <div id="welcome" ng-cloak class="dashboard-box" ng-if="first">\n' +
    '                    <a class="pull-right close" onclick="document.getElementById(\'welcome\').className=\'hidden\';"></a>\n' +
    '                    <h2 class="welcome">Welcome\n' +
    '                        <span class="hidden-xs">to P.E. For Hire!</span>\n' +
    '                    </h2>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-8 welcome">\n' +
    '                            <p>We are thrilled to have you as part of our community!\n' +
    '                                <br class="hidden-xs"> We will notify you immideatly upon request with matching qualifications is submitted. Requests\n' +
    '                                will be listed below.</p>\n' +
    '                            <p>In the meantime, we recommend that you take a few minutes to\n' +
    '                                <a href="join-engineer.htm">complete your Profile</a>. This is an opportunity to put your best foot forward and market\n' +
    '                                your skills to hiring parties.</p>\n' +
    '                        </div>\n' +
    '                        <div class="col-sm-4 col-md-3 col-md-offset-1">\n' +
    '                            <a class="btn btn-primary btn-lg btn-welcome" href="join-engineer.htm">Complete Profile</a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <!-- Sorting -->\n' +
    '            <div id="titleProject" ng-cloak class="col-xs-12">\n' +
    '\n' +
    '                <ul class="hidden-xs list-inline pull-right mt60">\n' +
    '                    <li class="form-group text-muted">\n' +
    '                        Display:\n' +
    '                    </li>\n' +
    '                    <li class="form-group" ng-repeat="value in paging.values">\n' +
    '                        <input id="list-{{value}}" class="form-control" name="pageMode" ng-model="paging.mode" ng-value="value" type="radio">\n' +
    '                        <label for="list-{{value}}">\n' +
    '                            <span></span>{{paging.display[$index]}}\n' +
    '                        </label>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '\n' +
    '                <ul class="hidden-xs list-inline pull-right mt60" style="margin-right: 100px;">\n' +
    '                    <li class="form-group text-muted">\n' +
    '                        Projects:\n' +
    '                    </li>\n' +
    '                    <li class="form-group" ng-repeat="value in target.values">\n' +
    '                        <input id="alist-{{value}}" class="form-control" name="pageMode2" ng-model="target.mode" ng-value="value" type="radio">\n' +
    '                        <label for="alist-{{value}}">\n' +
    '                            <span></span>{{target.display[$index]}}\n' +
    '                        </label>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '                <h2>Projects</h2>\n' +
    '            </div>\n' +
    '\n' +
    '            <!-- Start -->\n' +
    '            <table class="table table-striped">\n' +
    '\n' +
    '                <thead>\n' +
    '                    <tr>\n' +
    '                        <th class="hidden-xs">\n' +
    '                            <a href="">Posted</a>\n' +
    '                        </th>\n' +
    '                        <th>\n' +
    '                            <a href="">Engineer Type</a>\n' +
    '                        </th>\n' +
    '                        <th>\n' +
    '                            <a href="">Project Title</a>\n' +
    '                        </th>\n' +
    '                        <th>\n' +
    '                            <a href="">City</a>\n' +
    '                        </th>\n' +
    '                        <th>\n' +
    '                            <a href="">State</a>\n' +
    '                        </th>\n' +
    '                        <!--th class="hidden-xs">\n' +
    '                            <a href="">Work Remotely?</a>\n' +
    '                        </th-->\n' +
    '                        <th class="hidden-xs">\n' +
    '                            <a href="">Complete By</a>\n' +
    '                        </th>\n' +
    '                        <th class="hidden-xs">\n' +
    '                            <a href="">Share</a>\n' +
    '                        </th>\n' +
    '                        <th class="hidden-xs">\n' +
    '                            <a href="">Ignore</a>\n' +
    '                        </th>\n' +
    '                        <th>\n' +
    '                            <a href="">View</a>\n' +
    '                        </th>\n' +
    '                    </tr>\n' +
    '                </thead>\n' +
    '                <tbody>\n' +
    '                    <tr ng-repeat="request in requests">\n' +
    '                        <td class="hidden-xs">{{request.CreatedDate|standardMonthDayYear}}</td>\n' +
    '                        <td>\n' +
    '                            <a class="title" href="" ui-sref="project({uid: request.UID})">{{request.Label | characters:40}}</a>\n' +
    '                            <span ng-show="false" class="ellipsis"></span>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                            <a class="title" href="" ui-sref="project({uid: request.UID})">{{request.Title | characters:40}}</a>\n' +
    '                            <span ng-show="false" class="ellipsis"></span>\n' +
    '                        </td>\n' +
    '                        <td>{{request.City | titlecase}}</td>\n' +
    '                        <td>{{request.StateLicense}}</td>\n' +
    '                        <!--td class="hidden-xs">{{request.WorkRemote|yesNo}}</td-->\n' +
    '                        <td class="hidden-xs">{{request.WorkCompletedBy | workCompletedBy: request.WorkCompletedByDate}}</td>\n' +
    '                        <td class="hidden-xs">\n' +
    '                            <a href="" ng-click="openCopyProjectUrl(\'project\', {uid: request.UID, projectTitle: generateSeoUrlForRequest(request)})">URL</a>\n' +
    '                        </td>\n' +
    '                        <td class="hidden-xs">\n' +
    '                            <a ng-click="ignoreProject($index)" class="btn btn-default btn-xs">Ignore</a>\n' +
    '                        </td>\n' +
    '                        <td>\n' +
    '                            <a href="" ui-sref="project({uid: request.UID})" class="btn btn-primary btn-xs">View</a>\n' +
    '                        </td>\n' +
    '                    </tr>\n' +
    '                </tbody>\n' +
    '            </table>\n' +
    '            <!-- Pagination -->\n' +
    '            <div class="text-left" ng-show="paging.mode != paging.values[paging.values.length-1]">\n' +
    '                <div paging page="paging.current" ng-model="projectsAll" page-size="paging.mode" total="paging.total" paging-action="goToPage(page)"\n' +
    '                    prev="goToPage(paging.current-1)" next="goToPage(paging.current+1)"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    </div>\n' +
    '</section>');
}]);
